import { InvoiceService } from "./invoice.service";
import { OrganizationService } from "src/app/services/organizationservice";
import { AllUserInfoModel } from "./../store/storeModels/user.model";
import { OrgModel } from "src/app/store/storeModels/user.model";
import { Store } from "@ngrx/store";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router, NavigationExtras } from "@angular/router";
import { BehaviorSubject, Observable, of } from "rxjs";
import Swal from "sweetalert2";
import { AppState } from "../store/app.state";
import { UserModel } from "../store/storeModels/user.model";
import { environment } from "src/environments/environment";
import { Endpoints } from "../shared/config/endpoints";
import { Location } from "@angular/common";
import { ModalService } from "./modal.service";

@Injectable({
  providedIn: "root",
})

export class GeneralService {
  expiredToken = new BehaviorSubject<any>("");
  printActivated = new BehaviorSubject<boolean>(false);
  reloadService = new BehaviorSubject<boolean>(true);
  reloadComponent = new BehaviorSubject<boolean>(false);
  signedInUserDetails = new BehaviorSubject<any>("");
  tokenGenerated = new BehaviorSubject<string>("");
  httpStatus = new BehaviorSubject<string>("firstload");
  filterQueryClientIDs = new BehaviorSubject<string>("");
  showSpinner = new BehaviorSubject<boolean>(false);
  notchSpinner$ = this.showSpinner.asObservable();
  companyID = 3;
  fetchCurrency = new BehaviorSubject<any>("");
  teamIdSideBarFilter = new BehaviorSubject("");
  userSubject = new BehaviorSubject<AllUserInfoModel>(null);
  user$ = this.userSubject.asObservable();
  emitWorkflowId = new BehaviorSubject("");
  ticketTypeList$ = new BehaviorSubject<any[]>([]);
  reloadCompanDetail = new BehaviorSubject(false);
  reloadContactDetail = new BehaviorSubject(false);
  reloadBulkSMSApi = new BehaviorSubject(false);

  private selectedPipelineWorkflow: any = null;

  orgID;
  user: UserModel;
  org: OrgModel;
  orgModules: any[] = [];
  orgResources: any[] = []
  token;
  priviledges: string[];
  roleName: string;
  supervisor: boolean;
  plan: string;
  baseCurrency;
  rates;
  requireCreditProfile;
  organisationName = "";
  loadedModules = [];
  noAccessToFeatureMsg = '<p>Your license does not have access to this feature</p>';
  permissions = {
    modules: {
      tasks: 'TASKS',
      clients: 'CLIENTS',
    },
    resources: {
      email_integration: 'EMAIL_INTEGRATION',
      ticketing_website: 'TICKETING_WEBSITE',
      ticketing_email: 'TICKETING_EMAIL',
      ticketing_whatsapp: 'TICKETING_WHATSAPP',
      ticketing_call: 'TICKETING_CALL',
      ticketing_facebook: 'TICKETING_FACEBOOK_AND_INSTAGRAM',//'TICKETING_FACEBOOK',
      ticketing_twiter: 'TICKETING_TWITTER',
      credit_management: 'CREDIT_MANAGEMENT',
      social_monitoring_2: 'SOCIAL_MONITORING_2',
      activities: 'ACTIVITIES',
      report: 'REPORT',
      document_library: 'DOCUMENT_LIBRARY',
      api_keys: 'API_KEYS',
      days_count_configuration: 'SETTINGS_DAYS_COUNT_CONFIGURATION',
      bank_payments: 'SETTINGS_BANK_SETUP',
    }
  }
  userRel: any;

  constructor(
    private router: Router,
    private endpoints: Endpoints,
    private http: HttpClient,
    store: Store<AppState>,
    private orgServ: OrganizationService,
    private invoiceSrv: InvoiceService,
    private location: Location,
    private modalService: ModalService
  ) {
    store.select("userInfo").subscribe((info) => {
      if (info) {
        this.userSubject.next(info);
        this.userRel = info.userRel ? info.userRel : null;
        this.orgID = info.organization ? info.organization.id : null;
        this.org = info.organization
          ? { ...info.organization, orgImg: info.organization.displayUriPath }
          : null;
        this.supervisor = info.supervisor ? info.supervisor : null;
        this.user = info.user ? info.user : null;
        this.token = info.token ? info.token : null;
        this.priviledges = info.priviledges ? info.priviledges : [];
        this.roleName = info.roleName ? info.roleName : null;
        this.orgModules = info.organization && info.organization.modules ? info.organization.modules : [];
        this.orgResources = info.organization && info.organization.resources ? info.organization.resources : [];

        this.baseCurrency = info.organization
          ? info.organization.baseCurrency
          : null;
        this.rates = info.organization ? info.organization.rates : null;
        this.requireCreditProfile = info.organization
          ? info.organization.requireCreditProfile
          : null;
        this.teamIdSideBarFilter.next(
          this.user && this.user.teamID ? this.user.teamID.toString() : ""
        );
      }
    });
  }
  // Priviledge Access
  isAuthorized(permission: string): boolean {
    if (this.priviledges.indexOf(permission) >= 0 || this.isSuperAdmin) {
      return true;
    } else {
      return false;
    }
  }
  // Module Access
  canAccessModule(modulname: string): boolean {
    if (this.orgModules && this.orgModules.indexOf(modulname) >= 0) {
      return true;
    } else {
      return false;
    }
  }
  // Resource Access - based on license resources only (no Super Admin bypass)
  canAccessResource(resource: string): boolean {
    if (this.orgResources && this.orgResources.indexOf(resource) >= 0) {
      return true;
    } else {
      return false;
    }
  }
  get isSuperAdmin(): boolean {
    return this.roleName === "Super Admin" || (this.userRel && this.userRel.roleName === "Super Admin");
  }

  get isSupervisor(): boolean {
    return this.supervisor;
  }

  // Auth Pages
  isAuthPage(route: string): boolean {
    const authPages = [
      "/login",
      "/signup",
      "/complete-signup",
      "/forgot-password",
      "/resest-password",
      "/create-organization",
      "/welcome",
      "/otp",
    ];
    if (authPages.indexOf(`${route}`) >= 0) {
      return true;
    } else {
      return false;
    }
  }
  // Ticket email
  get orgEmailTicket() {
    const email = this.org.name.replace(/\s/g, "").toLowerCase();
    return `${email}${this.orgID}${environment.emailDomain}`;
  }

  get orgEmailInfo() {
    return `${this.orgID}${environment.emailDomain}`;
  }

  displaySpinner(moduleName: string) {
    if (!this.router.url.includes(moduleName)) {
      this.showSpinner.next(true);
    }
    if (this.loadedModules.indexOf(moduleName) >= 0) {
      this.showSpinner.next(false);
    } else {
      this.loadedModules.push(moduleName);
    }
  }
  get getSubmenEl() {
    return document.querySelector(".submenu-list");
  }
  goBack() {
    this.location.back();
  }

  // Fetch Templates
  fetchTemplates() {
    try {
      return this.http.get(
        `${this.endpoints.subscriptionQuotationInvoiceEndpoint}${this.endpoints.templates.getTemplates}`
      );
    } catch (error) {
      alert(error);
    }
  }
  orgInitSetup(org) {
    setTimeout(() => {
      this.orgServ.addSalesStat().subscribe((res) => {
      });
      this.invoiceSrv.orgTemplateSetup().subscribe((res) => {
      });
      this.setDefaultTicketType(org.id).subscribe((res) => {
      });
    }, 2000);
  }
  setDefaultTicketType(orgID) {
    const api = this.endpoints.ticketUrl;
    return this.http.post(api + `/${orgID}/defaultCreateTicket`, {});
  }
  // Handle Errors

  // Alert Message for Adding informations into the database
  alert(data: any) {
    const swalWithBootstrapButtons = Swal.mixin({});
    swalWithBootstrapButtons.fire(data.header, data.text, data.type);
  }

  checkIfObjectIsEmpty(objectName) {
    return (
      Object.keys(objectName).length === 0 && objectName.constructor === Object
    );
  }

  checkIfObjectOrArrayIsEmpty(objectOrArray) {
    if (objectOrArray === null || objectOrArray === undefined) {
      return true;
    }

    if (typeof objectOrArray === 'object') {
      return Object.keys(objectOrArray).length === 0 && objectOrArray.constructor === Object;
    }

    if (Array.isArray(objectOrArray)) {
      return objectOrArray.length === 0;
    }

    return false;
  }

  convertObjectToArray(object) {
    let finalArray = [];
    for (let key in object) {
      finalArray = [...finalArray, object[key]];
    }

    return finalArray;
  }

  putObjectKeysInArray(object) {
    let key_list = [];
    for (let key in object) {
      key_list.push(key);
    }

    return key_list;
  }

  /**
   *
   * @param amount Amount to format
   */
  format_as_money(amount) {
    const parts = amount.toString().split(".");
    const whole_part = parts[0];
    const decimal = parts[1] || `00`;
    const start_index = whole_part.length % 3;
    let formatted_sum = [whole_part.substr(0, start_index)];
    for (let i = start_index; i < whole_part.length; i += 3) {
      if (i == 0) formatted_sum.shift();
      formatted_sum.push(whole_part.substr(i, 3));
    }
    const result = `${formatted_sum.join()}.${decimal}`;
    return result;
  }

  /**
   *  Converts from one currncy to another
   * @param base_rate  The rate of the currency we are converting from. e.g from dollar to naira, dollar rate is the base rate
   * @param target_rate The rate of the currency we are converting to. e.g from dollar to naira, naira rate is the base rate
   * @param base_value  The amount of the base currency we want to convert from. e.g amount of dollars in dollar to naira conversion.
   */
  convertCurrency(base_rate: number, target_rate: number, base_value: number) {
    if (base_rate <= 0 || target_rate <= 0 || base_value <= 0) {
      return 0.0;
    }

    const target_value = (base_value * target_rate) / base_rate;
    return target_value.toFixed(2);
  }

  checkEmailIsValid(email: string): boolean {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(email.trim());
  }

  /*
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  swtAlertSuccess(type) {
    return Swal.fire({
      title: "Submitted!",
      text: `Your ${type} has been created.`,
      type: "success",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "rgb(43, 98, 107)",
      confirmButtonText: `View ${type}`,
      cancelButtonText: `Create new ${type}`,
    });
  }

  swtAlertDynoPrompt(title, text, confirmBtnTxt, cancelBtnTxt) {
    return Swal.fire({
      title: title,
      text: text,
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "rgb(43, 98, 107)",
      confirmButtonText: confirmBtnTxt,
      cancelButtonText: cancelBtnTxt,
    });
  }

  sweetAlertFileCreationSuccess(
    type,
    navigateUrl,
    navigationExtras?: NavigationExtras,
    secondNav?
  ) {
    return Swal.fire({
      title: "Submitted!",
      text: `${type} created.`,
      type: "success",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "rgb(43, 98, 107)",
      confirmButtonText: `View ${type}`,
      cancelButtonText: `Create new ${type}`,
    }).then((result) => {
      if (result.value) {
        navigationExtras
          ? this.router.navigate([navigateUrl], navigationExtras)
          : this.router.navigate([navigateUrl]);
      } else if (secondNav) {
        location.reload();
        this.router.navigate([secondNav]);
      }
      return result;
    });
  }

  sweetAlertFileCreateErrorWithoutNav(type) {
    Swal.fire({
      type: "error",
      title: `Oops... ${type} not created`,
      text: "Something went wrong!",
    });
  }

  sweetAlertFileUpdateSuccess(type, navigateUrl) {
    Swal.fire({
      title: "Submitted!",
      text: `Your ${type} has been updated.`,
      type: "success",
      // showCancelButton: true,
      confirmButtonColor: "#3085d6",
      // cancelButtonColor: 'rgb(43, 98, 107)',
      confirmButtonText: `View update`,
      // cancelButtonText: `View ${type}s`,
    })
    .then(result => {
    if (result.dismiss) {
      this.router.navigate([navigateUrl]);
    } else {
      // window.location.reload();
    }
    });
  }
  sweetAlertCreateSuccessWithoutNav(type) {
    Swal.fire({
      title: "Submitted!",
      text: `Your ${type} has been created.`,
      type: "success",
    });
  }

  sweetAlertFileUpdateSuccessWithoutNav(type) {
    Swal.fire({
      title: "Submitted!",
      text: `Your ${type} has been updated.`,
      type: "success",
    });
  }

  sweetAlertDeleteSuccess(type) {
    Swal.fire({
      title: "Submitted!",
      text: `Your ${type} has been deleted.`,
      type: "success",
    });
  }

  sweetAlertFileUpdateErrorWithoutNav(type) {
    Swal.fire({
      type: "error",
      title: `Oops... ${type} not updated`,
      text: "Something went wrong!",
    });
  }

  sweetAlertClientMerge(type) {
    return Swal.fire({
      title: `Merge ${type}?`,
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, merge it!",
    });
  }

  sweetAlertFileDeletions(type) {
    return Swal.fire({
      title: `Delete ${type}?`,
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
    });
  }

  sweetAlertTagDeletions(type) {
    return Swal.fire({
      title: `${type}?`,
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
    });
  }
  sweetAlertDeletionHtml(msg) {
    return Swal.fire({
      // title: `Delete ${type}?`,
      html: msg,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove!",
    });
  }

  sweetAlertGeneralDelete(title, btnText) {
    return Swal.fire({
      title: `${title}?`,
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${btnText}!`,
    });
  }

  ticketTyptDelete(title, btnText) {
    return Swal.fire({
      title: `${title}`,
      text: "It will affect existing tickets and can’t be reverted!.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${btnText}!`,
    });
  }


  sweetAlertFileCreations(type) {
    const frontal = type.includes("Copy") ? "" : "Create";
    return Swal.fire({
      title: `${frontal} ${type}?`,
      // text: 'You won\'t be able to revert this!',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm!",
    });
  }

  sweetAlertFileCreationsA(type) {
    const frontal = type.includes("Copy") ? "" : "Assign";
    return Swal.fire({
      title: `${frontal} ${type}?`,
      // text: 'You won\'t be able to revert this!',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm!",
    });
  }


  sweetAlertFileAssign(type) {
    const frontal = type.includes("Copy") ? "" : "Assign";
    return Swal.fire({
      title: `${frontal} ${type}?`,
      // text: 'You won\'t be able to revert this!',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm!",
    });
  }

  sweetAlertFileUpdates(type) {
    return Swal.fire({
      title: `Update ${type}?`,
      // text: 'You won\'t be able to revert this!',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });
  }

  sweetAlerTransitionUpdate(type) {
    return Swal.fire({
      title: `Move ${type}?`,
      type: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });
  }

  sweetAlertUpdates(message) {
    return Swal.fire({
      customClass: {
        container: "my-swal",
      },
      html: message,
      // text: 'You won\'t be able to revert this!',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });
  }

  sweetAlertUpdatesCompanyAndContact(message) {
    return Swal.fire({
      customClass: {
        container: "my-swal",
      },
      html: message,
      // text: 'You won\'t be able to revert this!',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Contact",
      cancelButtonText: "Company",
      showLoaderOnConfirm: true,
    });
  }

  sweetAlertUpdatess(message, observable: Observable<any>) {
    return Swal.fire({
      customClass: {
        container: "my-swal",
      },
      html: message,
      // text: 'You won\'t be able to revert this!',
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return observable
          .toPromise()
          .then((res) => {
            return {
              ...res,
              status: res.status ? res.status.toLowerCase() : "success",
            };
          })
          .catch((err) => {
            return { status: "error", error: err };
          });
      }
    });
  }

  sweetAlertIcon(imageUrl: string, imageClass, title: string) {
    return Swal.fire({
      imageUrl,
      // type: '',
      title,
      imageClass,
    });
  }

  sweetAlertAsync(
    type: "question" | "warning",
    message: string,
    observable: Observable<any>
  ) {
    console.log('type', type)
    return Swal.fire({
      customClass: {
        container: "my-swal",
      },
      html: message,
      type,
      text: type === "warning" ? "You won't be able to revert this!" : "",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return observable
          .toPromise()
          .then((res) => {
            return {
              ...res,
              status: res.status ? res.status.toLowerCase() : "success",
            };
          })
          .catch((err) => {
            return { status: "error", error: err };
          });
      },
      allowOutsideClick: false,
    });
  }

  sweetAlertSucess(msg) {
    return Swal.fire("Submitted", msg, "success");
  }

  sweetAlertCopied(msg = "") {
    return Swal.fire("Copied", msg, "success");
  }

  sweetAlertError(msg) {
    if (typeof msg === 'string' && msg.includes('Http failure response')) {
      msg = 'An error occurred. Please try again.';
    }
    return Swal.fire("Failed", msg, "error");
  }

  sweetAlertWarning({ message, title }) {
    title = title || 'info'
    return Swal.fire(title, message, "info");
  }

  sweetAlertFieldValidatio(fields) {
    return Swal.fire({
      //  title: `Update ${type}?`,
      html: `<pre> ${fields} </pre>`,
      type: "warning",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Okay",
      customClass: {
        popup: 'format-pre'
      }
    });
  }
  NoValue(value): boolean {
    if (value == "0" || (value as any) == 0 || value == null || value == "") {
      return true;
    } else {
      return false;
    }
  }

  sweetAlertLicence() {
    return Swal.fire({
      type: 'info',
      html:
        'Email integration function is not available for your license.<br> ' +
        'Upgrade licence to Access Functionality ',
      showCancelButton: true,
      confirmButtonText: `UPGRADE LICENCE`,
    }).then((result) => {
      if (result.value) {
        this.router.navigateByUrl("/settings/billing")
      }
    })
  }

  sweetAlertContinue(title) {
    return Swal.fire({
      title: `${title}?`,
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Continue!",
    });
  }

  sweetAlertNavigate(title) {
    return Swal.fire({
      title: `${title}?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#6d309c",
      confirmButtonText: "Yes",
      cancelButtonText: "Stay on Page",
    });
  }

  sweetAlertHTML(action, html, type?: any) {
    return Swal.fire({
      title: action,
      type: type || "warning",
      html: html,
    });
  }

  sweetAlertCreate(type) {
    return Swal.fire({
      title: `Create ${type}?`,
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, create it!",
    });
  }

  createTenantId() {
    return this.http.post(`http://localhost:3200/sales-stats/`, {
      orgId: "1",
    });
  }

  sendQuotationInvoice(payload) {
    try {
      const url = `${this.endpoints.communicationsEndpoint}/mailing/sales/quote`;
      return this.http.post(`${url}`, payload);
    } catch (error) {
      alert(error);
    }
  }

  printQuotationInvoice(payload) {
    try {
      const url = `${this.endpoints.fileServiceUrl}/attachments/pdf/conversion`;
      return this.http.post(`${url}`, payload);
    } catch (error) {
      alert(error);
    }
  }

  getInvoicePdf(payload) {
    try {
      const url = `${this.endpoints.fileServiceUrl}/attachments/sales-item/build`;
      return this.http.post(`${url}`, payload);
    } catch (error) {
      alert(error);
    }
  }

  getErrMsg(error): string {
    let msg = 'Error occurred, try again';
    if (error && error.error) {
      const { message, error: errorx } = error.error;
      msg = message || errorx || msg;
    }
    return msg;
  }

  notification(title, text, type, delay?) {
    return Swal.fire({
      title: title,
      text: text,
      type: type,
      timer: delay || 10000,
    });
  }
  sweetAlertInvoiceReceipt(type: string) {
    return Swal.fire({
      title: `${type}?`,
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm!",
    });
  }

  randomString() {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    let lenString = 15;
    let randomstring = '';
    for (let i = 0; i < lenString; i++) {
      let rnum = Math.floor(Math.random() * characters.length);
      randomstring += characters.substring(rnum, rnum + 1);
    }
    return randomstring;
  }

  sweetAlertSuccess(title, message) {
    Swal.fire({
      title: title,
      text: message,
      type: "success",
      confirmButtonColor: "#3085d6",
      confirmButtonText: `Ok`,
    });

  }

  sweetAlertProceed(title) {
    return Swal.fire({
      title: `${title}`,
      type: "question",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Proceed",
      allowOutsideClick: false
    });
  }

  sweetAlertInviteSuccess() {
    return Swal.fire({
      title: "Invite Email Sent Successfully",
      html: `
        <div class="text-center">
          <p>This user can only log into the system after a license has been assigned.</p>
          <p>If no license is assigned, they won't be able to log into the system.</p>
        </div>
      `,
      type: "success",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Proceed to Assign License",
      cancelButtonText: "Close",
      allowOutsideClick: false
    });
  }

  getCommandCenterHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'cmd-x-api-key': 'oncemoreintothefrayandintothelastgoodfight'
    });
  }

  setSelectedWorkflow(workflow: any) {
    this.selectedPipelineWorkflow = workflow;
  }

  getSelectedWorkflow(): any {
    return this.selectedPipelineWorkflow;
  }

  clearSelectedWorkflow() {
    this.selectedPipelineWorkflow = null;
  }
  get modal() {
    return this.modalService
  }
}
